import { API_ROUTES, useTitle } from "../helpers"
import $ from 'jquery';


export default function Vps() {

    useTitle('LMOAPPS - VPS')
//                     <!-- Add condition on logged user -->
    return (
        <>
            <div className="conteneur">
                <h1>VPS MANAGEMENT</h1>

                <div className="float-right">
                    <a href="./vps"><button className="btn btn-primary">VPS</button></a>
                    <a href="./house"><button className="btn btn-secondary">House</button></a>
                    <a href="./logout"><button className="btn btn-secondary">Logout</button></a>
                </div>
                <div className="clearfix"></div>
                <div id="flashMessages"></div>
                <div className="row">
                    <div className="col-sm-12 col-lg-4 col-md-6" style={{display: "inline-block"}} >
                    <h4> Service FTP </h4>
                    <button className="btn btn-toggle" disabled>
                        <span className="btn-toggle-content"></span>
                    </button>

                    <hr className="d-block d-md-none" />

                </div>

                <div className="col-sm-12 col-lg-6 col-md-6" id="dl-section">
                    <div className="">
                        <input type="text" id="dl-link" className="form-control" placeholder="Link to DL ..."
                            style={{maxWidth:"500px"}} onFocus={() => {$('#dl-link-action button').removeAttr('disabled')}} />
                        <img className="iloading" src="../img/loading2.gif" style={{width: "32px", height: "32px", display: "none"}} />
                        <br />
                        <label className="checkbox checkbox-inline"> <input type="checkbox" id="dl-link-direct" /> Lien direct
                        </label>
                    </div>
                    <div className="col-lg-4 col-md-4" id="dl-link-action">
                        <button className="btn btn-primary">Télécharger</button>
                    </div>
                    <div className="clearfix"></div>
                    <br />
                    <div className="alert alert-dl" style={{display:"none"}}>
                        <a href="#" className="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <h4 className="alert-title"></h4>
                        <br />
                        <div className="alert-message"></div>
                    </div>
                </div>
            </div>
            <div className="clearfix"></div>
            <hr />
            <div className="row">
                <div className="col-lg-6 col-md-12" id="part-fs">
                    <h5>Fichiers sur serveur (<span id="fs-free-space" className="font-weight-bold">--</span> disponible)
                        <img onClick={() => updateFilesFs()} src={require('../resources/img/refresh.png')} style={{cursor:"pointer", width: "32px", height: "32px"}} />
                    </h5>
                    <table id="fs-table-files" className="table table-bordered table-hover">
                        <tbody>
                            <tr className="iloading"><td colSpan="4"> <img src={require('../resources/img/loading.gif')} height="50px" width="60px" /></td></tr>
                        </tbody>
                    </table>
                    <hr className="d-block d-lg-none" />
                </div>

                <div className="col-lg-6 col-md-12" id="part-gd">
                    <h5>Fichiers sur GDrive (<span id="gd-free-space" className="font-weight-bold">--</span> disponible)
                        <img onClick={() => updateFilesGd()} src={require('../resources/img/refresh.png')}  style={{cursor:"pointer", width: "32px", height: "32px"}} />
                    </h5>
                    <table id="gd-table-files" className="table table-bordered table-hover">
                        <tbody>
                            <tr className="iloading"><td colSpan="4" className="text-center"> <img src={require('../resources/img/loading.gif')} height="50px" width="60px" /></td></tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </div>

        </>)
}

var filesGdUpdating = false;
var fileExchangePending = false;

var lineTemplateTableFs = '   <tr>\n' +
    '                            <td class="text-center"> <span style="word-break: break-word;">##FILENAME##</span>' +
    '                            (##FILE_SIZE##)' +
    '                               <br/> <button class="btn btn-warning" onclick="moveFileFSToGD(\'##FILENAME##\')">Envoi GD' +
    '                                </button>' +
    '                                <button class="btn btn-danger" onclick="deleteFileFS(\'##FILENAME##\')">Supprimer' +
    '                                </button>' +
    '                        </tr>';

var lineTemplateTableGd = '   <tr>\n' +
    '                            <td class="text-center"> <span style="word-break: break-word;">##FILENAME##</span>' +
    '                            (##FILE_SIZE##)' +
    '                               <br/> <button class="btn btn-warning" onclick="moveFileGDToFS(\'##FILENAME##\')">Envoi Serveur' +
    '                                </button>' +
    '                        </tr>';

var messageDl = '<div class="float-left">Téléchargement du fichier <b>##FILENAME##</b> : </div>' +
    '<div class="progress">\n' +
    '    <div class="progress-bar progress-bar-striped" role="progressbar" aria-valuenow="##PROGRESS##" aria-valuemin="0" aria-valuemax="100" style="width: ##PROGRESS##%">##PROGRESS##%</div>\n' +
    '  </div></div> <div class="clearfix"></div>';

$(function () {
    // updateFtpStatus();
    // updateFilesFs();
    // updateFilesGd();
});

/****************************************** PART UPDATES ******************************************/

function updateFtpStatus() {
    $.get(urlFtps, (data) => {
        console.log(data);
        if (data.isActive !== null) {
            if (data.isActive === true) {
                $('.btn-toggle').addClass('enabled');
            } else {
                $('.btn-toggle').removeClass('enabled');
            }
            $('.btn-toggle').removeAttr('disabled');
        }
    });
}

function updateFilesFs() {
    $.get(urlFilesFs, (data) => {
        $('#fs-free-space').text(data.freeSpace);
        $('#part-fs table tr:not(".iloading")').remove();
        for (let index in data.files) {
            let currentLineTemplate = lineTemplateTableFs;
            let item = data.files[index];
            currentLineTemplate = currentLineTemplate.replace(/\#\#FILENAME\#\#/g, item.name);
            currentLineTemplate = currentLineTemplate.replace(/##FILE_SIZE##/g, item.size);
            $('#part-fs tbody').append(currentLineTemplate);
        }
        $('#part-fs .iloading').hide();
    });
}

function updateFilesGd() {
    if (filesGdUpdating === false) {
        filesGdUpdating = true;
        $('#part-gd table tr:not(".iloading")').remove();
        $('#part-gd .iloading').show();
        $.get(urlFilesGd, (data) => {
            $('#gd-free-space').text(data.freeSpace);
            for (let index in data.items) {
                let currentLineTemplate = lineTemplateTableGd;
                let item = data.items[index];
                currentLineTemplate = currentLineTemplate.replace(/##FILENAME##/g, item.name);
                currentLineTemplate = currentLineTemplate.replace(/##FILE_SIZE##/g, item.sizeH);
                $('#part-gd tbody').append(currentLineTemplate);
            }
            $('#part-gd .iloading').hide();
        }).fail((response) => {
            let errorMessage = 'Erreur lors de la mise à jour GD [code ' + response.status + ']';
            console.log(response);
            if (response.responseJSON.error) {
                errorMessage += ' : ' + response.responseJSON.error;
            }
            setFlashMessage('error', errorMessage);
        })
            .always(() => {
                filesGdUpdating = false;
            })
        ;
    }
}

/****************************************** PART MOVE FILES FS <==> GD ******************************************/

async function moveFileFSToGD(filename) {
    if (fileExchangePending === false) {
        fileExchangePending = true;
        var terminated = false;
        $.post(urlFilesFs2Gd, {filename: filename}, (data) => {
                setFlashMessage('success', 'Envoi du fichier <b>' + filename + '</b> vers GD réussi !')
                updateFilesGd();
                updateFilesFs();
            }
        ).fail(error => {
            let msg='Envoi du fichier <b>' + filename + '</b> vers GD en échec';
            if(error.responseJSON && error.responseJSON.output){
                msg+=' : '+error.responseJSON.output;
            }
            setFlashMessage('error', msg);
        }).always(() => {
            terminated = true;
            fileExchangePending = false;
        });
        setFlashMessage('info', 'Envoi du fichier <b>' + filename + '</b> vers GD en cours ...');
        while (terminated !== true) {
            $.post(urlFilesFs2GdStatus, {filename: filename}, (data) => {
                    if (terminated !== true && data.status && data.status !== 'COMPLETE') {
                        setFlashMessage('info', 'Envoi du fichier <b>' + filename + '</b> vers GD : <b>' + data.status + '</b>');
                    }
                }
            );
            await new Promise(r => setTimeout(r, 2500));
        }
    } else {
        console.log('Pending requests, skipping order.')
    }
}

async function moveFileGDToFS(filename) {
    if (fileExchangePending === false) {
        fileExchangePending = true;
        var terminated = false;
        $.post(urlFilesGd2Fs, {filename: filename}, (data) => {
                setFlashMessage('success', 'Envoi du fichier GD <b>' + filename + '</b> vers le serveur réussi !')
                updateFilesFs();
                updateFilesGd();
            }
        ).fail(error => {
            let msg='Envoi du fichier GD <b>' + filename + '</b> vers le serveur en échec';
            if(error.responseJSON && error.responseJSON.output){
                msg+=' : '+error.responseJSON.output;
            }
            setFlashMessage('error', msg);
        }).always(() => {
            terminated = true;
            fileExchangePending = false;
        });

        setFlashMessage('info', 'Envoi du fichier <b>' + filename + '</b> vers le serveur en cours ...');

        while (terminated !== true) {
            $.post(urlFilesGd2FsStatus, {filename: filename}, (data) => {
                    if (terminated !== true && data.status && data.status !== 'COMPLETE') {
                        setFlashMessage('info', 'Envoi du fichier <b>' + filename + '</b> vers le serveur : <b>' + data.status + '</b>');
                    }
                }
            );
            await new Promise(r => setTimeout(r, 2500));
        }
    } else {
        console.log('Pending requests, skipping order.')
    }
}

function deleteFileFS(filename) {
    let confirmation = confirm('Vraiment supprimer ' + filename + ' ?');
    if (confirmation === true) {
        $.post(urlDelFileFs, {filename: filename}, () => {
            setFlashMessage('success', 'File <b>' + filename + '</b> deleted successfully !')
            updateFilesFs();
        });
    }
}

/****************************************** PART EVENTS ACTIONS ******************************************/

$('.btn-toggle').on('click', function () {
    $('.btn-toggle').attr('disabled', '');
    let activation = !($('.btn-toggle').hasClass('enabled'));
    $.post(urlFtps, {activation: activation}, () => {
        updateFtpStatus();
    });
});

$('#dl-link-action button').on('click', () => {
    let link = $('#dl-link').val();
    let isDirectLink = $('#dl-link-direct').is(':checked');
    if (link.length > 5) {
        let queryParamsStr = '?link=' + link + "&directLink=" + isDirectLink
        $('#dl-section input, #dl-section button').attr('disabled', true)
        $('#dl-section .alert-dl').hide();
        $('#dl-section .iloading').show();
        $.get(urlDll + queryParamsStr, async (data) => {
            let filename = data.filename;
            setFlashMessage('info', 'Téléchargement du fichier <b>' + filename + '</b> en cours ...');
            var terminated = false;
            while (terminated !== true) {
                $.post(urlDllStatus, {filename: filename}, (data) => {
                        if (terminated !== true && data.status) {
                            if (data.status === 'COMPLETE') {
                                setFlashMessage('success', 'Téléchargement du fichier <b>' + filename + '</b> terminé avec succès !');
                                terminated = true;
                                updateFilesFs();
                            } else {
                                let progressValue = data.status.replace('%', '');
                                let message = messageDl;
                                message = message.replace(/##FILENAME##/g, filename);
                                message = message.replace(/##PROGRESS##/g, progressValue);
                                setFlashMessage('info', message);
                            }
                        }
                    }
                ).fail(error => {
                    terminated = true;
                    setFlashMessage('error', 'Téléchargement du fichier <b>' + filename + '</b> en échec : ' + error.responseJSON.output)
                });
                await new Promise(r => setTimeout(r, 2500));
            }
        }).fail((error) => {
            let errorMessage = 'Erreur lors du téléchargement [code ' + error.status + ']';
            if (error.responseJSON.message) {
                errorMessage += ' : ' + error.responseJSON.message;
            }
            setFlashMessage('error', errorMessage);
        })
            .always(() => {
                $('#dl-section input').removeAttr('disabled');
                $('#dl-section .iloading').hide();
            });
    }
});


